import React, { useState } from "react";

// Toggle de tema claro/oscuro. Persiste en localStorage('esen-theme')
// y aplica data-theme en <html> (el script de index.html lo lee al cargar).
const ThemeToggle = ({ variant }) => {
  const [dark, setDark] = useState(
    document.documentElement.getAttribute("data-theme") === "dark"
  );

  const toggle = () => {
    const next = dark ? "light" : "dark";
    if (next === "dark") {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
    try {
      localStorage.setItem("esen-theme", next);
    } catch (e) {}
    setDark(!dark);
  };

  return (
    <button
      type="button"
      className={
        variant === "page" ? "esen-theme-toggle esen-theme-toggle--page" : "esen-theme-toggle"
      }
      onClick={toggle}
      aria-pressed={dark}
      title={dark ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
    >
      <i className={dark ? "fa fa-sun-o" : "fa fa-moon-o"} aria-hidden="true"></i>
      <span>{dark ? "Tema claro" : "Tema oscuro"}</span>
    </button>
  );
};

export default ThemeToggle;
